import { PATH_ROOTS } from '@common/constants';
import { CommonActionTypes, EditMode } from '@common/types';
import { decreaseLoaderCount, increaseLoaderCount } from '@common/utils/reduxUtils';
import produce from 'immer';

import { ConnectorEventTypes, ProjectEventTypes } from '../types';
import { actionTypes, DQ_IDE_ACTION_TYPES, ObservationGraph, ObservationState, ResetObservationKeyWord } from './types';

export const reducer = produce(function reducer(
  draft: ObservationState,
  action: DQ_IDE_ACTION_TYPES
): ObservationState {
  switch (action.type) {
    case CommonActionTypes.loaderOn: {
      increaseLoaderCount(draft, action?.payload?.hasCountSame);
      break;
    }
    case CommonActionTypes.loaderOff: {
      decreaseLoaderCount(draft, action.payload?.resetLoaderCount);
      break;
    }
    case actionTypes.setProject: {
      draft.metadata.project = action.payload.project;
      draft.dataQuality = {
        observations: [],
        dates: [],
        eventType: action.payload.event || ProjectEventTypes.AttentionRequired
      };
      draft.observationMetadata.fabricId = action.payload.fabricId;
      draft.observationMetadata.startDateTo = new Date();
      draft.observationMetadata.startDateFrom = undefined;
      break;
    }
    case actionTypes.setProjectEventType: {
      draft.dataQuality.eventType = action.payload.eventType;
      break;
    }
    case actionTypes.setConnetorEventType: {
      draft.connectorObservation.eventType = action.payload.eventType;
      break;
    }
    case actionTypes.changeFabric: {
      draft.observationMetadata.hasFabric = true;
      draft.observationMetadata.fabricId = action.payload;
      break;
    }
    case actionTypes.setObservationDate: {
      const observationDate = action.payload;
      if (observationDate !== ResetObservationKeyWord) {
        draft.observationMetadata.startDateFrom = action.payload as number;
      } else {
        draft.observationMetadata.startDateFrom = undefined;
        draft.observationMetadata.startDateTo = new Date();
      }

      draft.observationMetadata.isLoadingMoreData = true;
      break;
    }
    case actionTypes.setIsLoadingMoreData: {
      draft.observationMetadata.isLoadingMoreData = action.payload;
      break;
    }
    case actionTypes.setStatus: {
      draft.dataQuality.selectedStatus = action.payload.status;
      break;
    }
    case actionTypes.setProjectObservations: {
      const { payload } = action;
      draft.loader = false;
      draft.observationMetadata.isLoadingMoreData = false;
      draft.dataQuality.observations = payload.observations;
      break;
    }
    case actionTypes.validationError:
      draft.currentGraph =
        draft.currentGraph ?? ({ metainfo: { versionedAspect: defaultversionAspect } } as unknown as ObservationGraph);
      break;
    case actionTypes.setConnectorEvents:
      draft.connectorObservation.events = action.payload.events;
      draft.observationMetadata.isLoadingMoreData = false;
      break;
    case actionTypes.setSelectedConnectorName:
      draft.connectorObservation.selectedConnectorName = action.payload.connectorName;
      break;

    default:
      break;
  }
  return draft;
});

const defaultversionAspect: string = `{ version: '1.0', expectations: [] }`;

const graph = {
  metainfo: {
    versionedAspect: defaultversionAspect,
    errorMessage: ''
  }
} as unknown as ObservationGraph;

export const initialState: ObservationState = {
  editMode: EditMode.enabled,
  banner: '',
  loaderCount: 0,
  root: PATH_ROOTS.EXPECTATION,
  graphPath: PATH_ROOTS.EXPECTATION,
  currentGraph: graph,
  loader: false,
  gemSpecs: [],
  connectorObservation: {
    events: [],
    eventType: ConnectorEventTypes.AttentionRequired,
    selectedConnectorName: ''
  },
  observationMetadata: {
    fabricId: '',
    hasFabric: false,
    isLoadingMoreData: false,
    startDateTo: new Date()
  },
  dataQuality: {
    observations: [],
    dates: [],
    eventType: ProjectEventTypes.AttentionRequired
  },
  metadata: {}
};
